import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  competencyTest: {},
  evaluation: {}
}

let state = Object.assign({}, defaultState)

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/surveys/index.js